<template>
<div class='hs-list-page flex-v'>
  <div v-if='breadcrumb && breadcrumb.length' class='flex-item hs-breadcrumb'>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item
        v-for='(m, i) in breadcrumb'
        :key='i'
        v-bind='m'
      >{{ m.rawLabel || (m.label ? t(m.label) : '') }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <hs-search-bar
    ref='form'
    v-if='form && form.length'
    class='flex-item'
    :formData='form'
    v-bind='elFormProps'
    @search='search'
    @reset='reset'
  />
  <div class='flex-main flex-v table-wrap'>
    <hs-button-group v-if='btns && btns.length' class='flex-item' :btns='btns'></hs-button-group>
    <hs-table ref="table" class='flex-main' :data='tableData' :columns='columns' v-bind='tableProps' :elProps='elTableProps' v-on="{...elTableEvents}"/>
    <div class='pagination flex-item' v-if='pagination'>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="pageSizes"
        :total='total'
        :current-page='pageIndex'
        :page-size='pageSize'>
      </el-pagination>
    </div>
  </div>
</div>
</template>

<script>
import HsSearchBar from '../searchBar'
import HsTable from '../table'
import HsButtonGroup from './buttonGroup'
import Locale from '../../mixins/locale'

export default {
  name: 'HsListPage',
  mixins: [Locale],
  components: {
    HsSearchBar,
    HsTable,
    HsButtonGroup,
  },
  props: {
    /**
     * 面包屑导航
     */
    breadcrumb: Array,
    /**
     * 搜索条表单配置
     */
    form: Array,
    /**
     * 按钮组
     */
    btns: Array,
    /**
     * <a href='/?path=/docs/组件-table--basic-table'>表格列</a>
     */
    columns: Array,
    /** HsTable支持的属性配置对象 */
    tableProps: Object,
    /** ElTable支持的属性配置对象 */
    elTableProps: Object,
    /** ElTable支持的方法对象 */
    elTableEvents: Object,
    /** ElForm支持的属性配置对象 */
    elFormProps: Object,
    /**
     * <a href='/?path=/docs/组件-table--basic-table'>表格数据</a>
     */
    data: {
      type: Array,
      default () {
        return []
      }
    },
    /**
     * 分页器配置
     */
    pagination: Object,
    /**
     * 表格数据加载方法
     */
    loader: {
      type: Function,
      default () {
        Promise.resolve({ list: [] })
      }
    },
    /**
     * 是否立即查询数据
     */
    immediate: {
      type: Boolean,
      default: true,
    }
  },
  data () {
    const { total, pageIndex, pageSize, pageSizes } = Object.assign({
      total: 0,
      pageIndex: 1,
      pageSize: 30,
      pageSizes: [30, 50, 100]
    }, this.pagination)
    return {
      tableData: this.data,
      total,
      pageIndex,
      pageSize,
      pageSizes
    }
  },
  mounted () {
    if (this.immediate) this.reload()
  },
  methods: {
    reload () {
      const param = this.getSearchParam()
      this.loader(param, data => {
        this.tableData = data.list
        if(this.pagination) {
          this.total = data.total
        }
      })
    },

    search() {
      this.pageIndex = 1
      this.reload()
    },
    reset (v) {
      this.$emit('reset', v)
    },

    /**
     * 重新计算表格布局
     */
    doTableLayout () {
      this.$refs.table.doLayout()
    },

    /**
     * 获取页面查询参数，包括搜索条件及分页信息
     */
    getSearchParam () {
      let formData = {}
      if (this.pagination) {
        formData.pageIndex = this.pageIndex
        formData.pageSize = this.pageSize
      }
      if (this.form && this.form.length) {
        formData = {
          ...formData,
          ...this.$refs.form.getFormData()
        }
      }
      return formData
    },

    handleSizeChange (size) {
      this.pageSize = size
      this.reload()
    },
    handleCurrentChange (pageIndex) {
      this.pageIndex = pageIndex;
      this.reload()
    }
  }
}
</script>

<style scoped lang='scss'>
@import '../../theme/var.scss';
.hs-list-page {
  height: 100%;
}
.hs-breadcrumb {
  padding: 8px;
}
.table-wrap {
  flex-shrink: 0;
  padding: 10px;
  background: $--color-white;
  border-radius: $--border-radius-large;
}
.pagination {
  margin-top: 10px;
  text-align: right;
}
</style>